import { toast } from 'react-toastify';

import { API_DOMAIN } from '../const';

export default function Fetcher(uri, request_method, callback, data, quietMode) {
    const req_params = {
        method: request_method,
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
    };

    if (data) {
        req_params.body = JSON.stringify(data || '');
    }

    return fetch(API_DOMAIN + uri, req_params)
        .then((response) => {
            if (!response.ok) {
                throw response.json();
            }

            if (window.location.pathname.includes('contentmanager/maillist') && response.status === 201) { // email-рассылка
                toast.success('Успешно отправлено!');
                callback && callback();

                return;
            }

            if (response.status === 204) {
                return '';
            }

            return response.json();
        })
        .then((data) => {
            callback && callback(data);

            if (quietMode) {
                return;
            }

            if (request_method === 'POST' || request_method === 'PUT' || request_method === 'PATCH') {
                toast.success('Успешно сохранено!');
            } else if (request_method === 'DELETE') {
                toast.success('Успешно удалено!');
            }
        })
        .catch((error) => {
            console.log(error);

            if (error && typeof error.then === 'function') {
                error.then((e) => {
                    let error_message = e.detail;

                    if (!error_message) {
                        error_message = JSON.stringify(e);
                    }

                    if (request_method === 'POST' || request_method === 'PUT') {
                        toast.error(`Ошибка сохранения \n${error_message}`);
                    } else if (request_method === 'DELETE') {
                        toast.error(`Ошибка удаления \n${error_message}`);
                    } else {
                        toast.error(`Ошибка загрузки данных \n${error_message}`);
                    }
                });
            }

            return error;
        });
}
